<template>
  <v-container fluid style="padding: 0; margin: 0;">
    <Logo :show="false" :isSwitchLanguage="false" />
    <v-row no-gutters>
      <v-col md="2" offset-md="5">
        <v-list >
          <v-list-item-group v-model="model" >
            <v-list-item v-for="(item, i) in items" :key="i" style="border: 1px solid #b3a258; border-radius: 5px;">
              <v-list-item-content >
                <a :href="item.url" target="_blank" class="link">
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                </a>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Logo from "@/components/Logo.vue";
export default {
  components: {
    Logo
  },
  data() {
    return {
      item: 1,
      items: [
        {
          text: "简体中文",
          icon: "mdi-file",
          url:
            "/data/A-Explore Points Chart_CH.pdf"
        },
        {
          text: "English",
          icon: "mdi-file",
          url:
            "/data/A-Explore Points Chart_EN.pdf"
        }
      ]
    };
  }
};
</script>

<style lang="sass" scoped>
.link 
  text-decoration: none
  color: #b3a258
</style>